import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ConfigProvider } from 'antd';
import RootRoutes from './routes/routes';
import { store, persistor } from './store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ConfigProvider
    theme={{
      token: {
        fontFamily: '"Inter", sans-serif',
      },
      components: {
        Typography: {
          colorTextHeading: '#262626',
          titleMarginBottom: 0,
          titleMarginTop: 0,
          colorTextDescription: '#8C8C8C',
        },
        Tag: {
          marginXS: 0,
        },
      },
    }}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options}> */}
        <RootRoutes />
        {/* </PostHogProvider> */}
      </PersistGate>
    </Provider>
  </ConfigProvider>,
);
